import React from 'react'
import CyclesByOperatorPanel from '../../../../components/material/DeviceDashboard/CyclesByOperator/CyclesByOperatorPanel'
import { useDispatch, useSelector } from 'react-redux';

const CyclesByOperatorContainer = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const { deviceCycles } = useSelector((store) => store.devicedashboard);
    // @ts-ignore
    const loading = useSelector((store) => store.devicedashboard.loading.cyclesByOperator);

    return (
        <CyclesByOperatorPanel deviceCycles={deviceCycles} loading={loading} />
    )
}

export default CyclesByOperatorContainer
